<script>
import { updateSelection, fromHeaders, isSelected } from '@/utils'

export default {
  functional: true,
  props: {
    item: Object,
    emitSelection: Function,
    selection: Array,
    headers: Array,
    actions: Array,
    hasActions: Boolean,
    isDetail: { type: Boolean, default: false },
  },
  render: (h, { props }) => {
    const {
      headers,
      item,
      selection,
      emitSelection,
      hasActions,
      actions,
      isDetail,
    } = props

    let badge = item.badge
      ? <v-flex align-end class="px-4">
        <v-badge color="purple">
          <span slot="badge">{ item.badge }</span>
          <span> </span>
        </v-badge>
      </v-flex>
      : null
    let hasMedia = item['img_path'] !== undefined
    let isArchived = item.deleted_at !== undefined && item.deleted_at !== null
    let imgPath = item.img_path
      ? `${process.env.VUE_APP_API_REST_URL}${item.img_path}`
      : '/img/placeholder.png'
    let readState = item.read !== undefined ? item.read === 0 : false

    let dataClass = {
      'unread': readState,
    }
    let tileClass = {
      'blue-grey lighten-2': isArchived,
      'py-1': true,
      'my-list-tile': true,
    }
    let mediaElm = isDetail
      ? <v-card-media><img src={imgPath} /></v-card-media>
      : <v-card-media src={imgPath} height="150px">{badge}</v-card-media>
    let media = hasMedia
      ? mediaElm
      : null
    let selected = isSelected(item, selection)
    const doSelect = (value) => { updateSelection(item, selection, value, emitSelection) }
    let actionElems = hasActions
      ? actions.map((action, idx) => {
        const doCallBack = e => {
          action.callBack(item)
        }
        return (
          <v-btn key={idx} icon small on-click={doCallBack}>
            <v-icon small >{action.icon}</v-icon>
          </v-btn>
        )
      })
      : null

    let actionsBlock = !isDetail && !isArchived
      ? <v-flex class="py-0 px-0">
        <v-divider />
        <v-card-actions class="py-0">
          <v-spacer/>
          { actionElems }
          <v-checkbox
            class="shrink"
            hide-details
            input-value={ selected }
            on-change={ doSelect }
          />
        </v-card-actions>
      </v-flex>
      : null

    let data = fromHeaders(headers, item)
    let body = data.map((one, idx) => (
      <v-flex class="py-0 px-0" key={idx}>
        <v-divider />
        <v-list-tile class="" class={tileClass}>
          <v-list-tile-content >
            <v-list-tile-sub-title class="italic">{ one.label }:</v-list-tile-sub-title>
            <v-list-tile-title class={ dataClass }>{ one.value }</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-flex>
    ))
    return (
      <v-card>
        { media }
        <v-card-text class="px-0 py-0">
          <v-list dense class="py-0">
            { body }
          </v-list>
        </v-card-text>
        { actionsBlock }
      </v-card>
    )
  },
}
</script>

<style>
.my-list-tile .v-list__tile {
  height: auto !important;
}
</style>

<style scoped>
.archived .v-card__text{
  background-color: #000;
}
.v-list__tile__sub-title,
.v-list__tile__title {
  line-height: normal;
  height: auto;
  overflow-wrap: break-word;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}
.v-card__actions .v-input {
  margin-top: 0;
}
img {
  height: 100%;
  width: 100%;
}
.unread {
  font-weight: bold;
}
</style>
